import { Injectable } from "@angular/core";
import { Observable, Subject, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { PaymentMethod } from "../../constants/payments-methods.constants";
import { HttpService } from "../http/service";

@Injectable()
export class PayzenService {
  public paymentMethod = PaymentMethod;
  private verifyDirectDebitSubject = new Subject<void>();
  public verifyDirectDebit$ = this.verifyDirectDebitSubject.asObservable();

  constructor(private httpService: HttpService) {}

  public getPayzenEnvironment(
    transactionPaymentMethod: number,
  ): Observable<any> {
    if (transactionPaymentMethod == this.paymentMethod.payzenDebit) {
      return this.httpService.get("get-payzen-env-debito").pipe(
        map((response: any) => {
          return response;
        }),
        catchError((e) => throwError(e)),
      );
    }
    if (
      transactionPaymentMethod == this.paymentMethod.payzenCreditInstallments
    ) {
      return this.httpService.get("get-payzen-env-credito-installments").pipe(
        map((response: any) => {
          return response;
        }),
        catchError((e) => throwError(e)),
      );
    }
    return this.httpService.get("get-payzen-env-credito").pipe(
      map((response: any) => {
        return response;
      }),
      catchError((e) => throwError(e)),
    );
  }

  public verifyApplyDirectDebit(transactionId: string): Observable<any> {
    return this.httpService
      .get("verifyApplyDirectDebit", null, transactionId)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((e) => throwError(e)),
      );
  }
  public verifyDirectDebit(electronicPaymentCode: string): Observable<any> {
    return this.httpService
      .get("verifyDirectDebit", null, electronicPaymentCode)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((e) => throwError(e)),
      );
  }
  public joinDirectDebit(transactionId: string): Observable<any> {
    return this.httpService.create("joinDirectDebit", null, transactionId).pipe(
      map((response) => {
        return response;
      }),
      catchError((e) => throwError(e)),
    );
  }
  public cancelDirectDebit(transactionId: string): Observable<any> {
    return this.httpService
      .delete("cancelDirectDebit", transactionId, null)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((e) => throwError(e)),
      );
  }
  public changeCardDirectDebit(transactionId: string): Observable<any> {
    return this.httpService
      .edit("changeCardDirectDebit", null, transactionId)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((e) => throwError(e)),
      );
  }

  public checkPaymentLimitExceeded(transactionId: string): Observable<boolean> {
    return this.httpService
      .get("payzen-limit-for-transaction", null, transactionId)
      .pipe(
        map((response: any) => {
          return response.limitExceeded;
        }),
        catchError((e) => throwError(e)),
      );
  }

  public savePayerInformationForPayment(
    transactionId: string,
    data: { payerName: string; payerDocumentNumber: string },
  ): Observable<any> {
    return this.httpService
      .edit("save-payer-information-payment", data, transactionId)
      .pipe(
        map((response: any) => response),
        catchError((e) => throwError(e)),
      );
  }

  public savePayerInformationForTokenization(
    tokenizationRequestId: number,
    data: { payerName: string; payerDocumentNumber: string },
  ): Observable<any> {
    return this.httpService
      .edit("save-payer-information-tokenization", data, tokenizationRequestId.toString())
      .pipe(
        map((response: any) => response),
        catchError((e) => throwError(e)),
      );
  }

  triggerVerifyDirectDebit(): void {
    this.verifyDirectDebitSubject.next();
  }
}
